var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "comment-modal",
        centered: "",
        "hide-footer": "",
        "hide-header": "",
      },
      on: {
        close: function ($event) {
          _vm.isOpen = false
        },
      },
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c(
        "div",
        { staticClass: "m-comment" },
        [
          _c("svg-icon", {
            staticClass: "modal-dialog__close",
            attrs: { size: "8", name: "times-bold" },
            on: { click: _vm.close },
          }),
          _c("div", { staticClass: "m-comment__text" }, [
            _vm._v(_vm._s(_vm.text)),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }